/* globals jQuery */
import 'fitvids.1.1.0'

import './slideshows.js'
import responsiveNav from './responsive-nav.js'
import accordion from './jquery.accordion.js'
import './gsap-anchor-nav.js';
import {initAlert} from './alert-bar.js'

(($) => {

    //$.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    initAlert();

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'dropdown'
        });
    }

    const jumpNav = document.querySelector('.jump-links-nav');
    if(jumpNav){
        responsiveNav(jumpNav,{
            wrapperSelector: '.jump-links-wrapper',
            navType: 'dropdown',
            menuButtonSelector: '.jump-links-toggle'
        });
    }

    // Responsive Videos
    $('.rtecontent, .video').fitVids({ ignore: '.tableauViz'});

    // Accordions
    $('dl.accordion').accordion();

    //filter on change
    $('.js-goOnChange').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    // Get all buttons with the class 'js-show-video-dialog'
    const showVideoDialogButtons = document.querySelectorAll('.js-show-video-dialog');
    // Loop through each button
    showVideoDialogButtons.forEach(showButton => {

        // Get the next element, which is assumed to be the dialog
        let dialog = showButton.nextElementSibling;
        let closeButton = dialog.querySelector(".popover__close");

        // "Show the dialog" button opens the dialog modally
        showButton.addEventListener('click', () => {
            dialog.showModal();
        });
        // "Close" button closes the dialog
        closeButton.addEventListener("click", () => {
            dialog.close();
        });

        dialog.addEventListener('close', () => {
            //a bit of a hacky way to make sure the video doesn't kep playing when the dialog is clsoed
            let iframe = dialog.querySelector('iframe');
            let srcAttribute = iframe.getAttribute('src');
            iframe.removeAttribute('src');
            iframe.setAttribute('src',srcAttribute);
        });

    });

    $('.js-social-share').on("click", function(e) {
        // Prevent default anchor event
        e.preventDefault();

        // Set values for window
        let intWidth = '500';
        let intHeight = '400';
        let strResize = 'yes';
        let href = $(this).attr('href');

        // Set title and open popup with focus on it
        var strTitle = ((typeof $(this).attr('title') !== 'undefined') ? $(this).attr('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,            
            objWindow = window.open(href, strTitle, strParam).focus();
    });


})(jQuery)
